import React from 'react';
import { InformationalCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('candidate_search.email_modal');

const BulkEmailCallout = () => {
  return (
    <InformationalCallOut
      headerText={t('bulk_body')}
      bodyText={t('all_tokens')}
    />
  );
};

export default BulkEmailCallout;
